export enum CompanyMilestonesBlock {
  Root = 'CompanyMilestones',
}
